import { render, staticRenderFns } from "./MineMore.vue?vue&type=template&id=2c640d43&scoped=true&"
import script from "./MineMore.vue?vue&type=script&lang=js&"
export * from "./MineMore.vue?vue&type=script&lang=js&"
import style0 from "./MineMore.vue?vue&type=style&index=0&id=2c640d43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c640d43",
  null
  
)

export default component.exports